<template>
  <div class="container-sortlist">
    <div class="sort-list">
      <el-radio-group v-model="input">
        <el-radio-button
          class="sort-radio"
          v-for="(item, index) in options"
          :key="index"
          :label="item.no"
          >{{ item.name }}
          <i class="el-icon-bottom" v-if="item.no !== 1" />
        </el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "SortList",
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    isCondition: {
      // false-默认进入筛选条件初始化
      type: Boolean,
      default: false,
    },
    isCard: {
      // 是否是form表单
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cssstyle: {
      // 自定义样式
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      initValue: "",
      curentField: ''
    };
  },
  computed: {
    input: {
      get() {
        return this.initValue;
      },
      set(val) {
        this.initValue = val;
        let res = [];
        res = this.options.filter((item) => item.no === this.initValue);
        if (res && res.length) {
          this.$emit("click", {
            val: res[0].no,
            field: this.field,
            name: res[0].name,
            isCard: this.isCard,
            isCondition: this.isCondition,
          });
        }
      },
    },
  },
  mounted() {
    let res;
    this.initValue = this.value;
    this.curentField = this.field
    res = this.options.filter((item) => item.no === this.initValue);
    if(res && res.length) {
      this.$emit("initFormData", {
        val: res[0].no,
        field: this.field,
        name: res[0].name,
        isCard: this.isCard,
        isCondition: this.isCondition,
      });
    } else {
      this.$emit("initFormData", {
        val: this.initValue,
        field: this.field,
        name: '',
        isCard: this.isCard,
        isCondition: this.isCondition,
      });
    }
    
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container-sortlist {
  flex: 1;
  display: flex;
  align-items: center;
  .sort-list {
    .sort-radio:nth-child(1) {
      /deep/ .el-radio-button__inner {
        padding-left: 0;
      }
    }
    /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #fff !important;
      border: none;
      color: #e40e1b !important;
      box-shadow: none;
      border-left: 1px solid #ccc;
    }
    /deep/.el-radio-button__inner {
      border: none;
      border-left: 1px solid #ccc;
    }
    /deep/ .el-radio-button:first-child .el-radio-button__inner {
      border: none !important;
    }
    /deep/ .el-radio-button__inner:hover {
      color: #e40e1b !important;
    }
    /deep/ .el-radio-button__inner {
      padding: 5px 20px;
    }
  }
}
</style>
